import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "person-sync",
  "use": "person-sync-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"person-sync\"><path d=\"M1.416 17.25a6.753 6.753 0 019.4-6.208\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M8.166 9a4.125 4.125 0 100-8.25 4.125 4.125 0 000 8.25z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M20.166 15.75h3.75v-4.5M23.727 15.75a6 6 0 10-1.122 5.242\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/person-sync.svg
// module id = Hdi5
// module chunks = 39 44